import { createApiSaga } from '../../../sagaGenerator';
import { apiDelete, apiGet } from '../../../../middleware/api';
import {
  TSU_REL_DEPOSIT_DATA_TSUNAMI_REQUEST,
  TSU_REL_DEPOSIT_DATA_PUBLICATION_REQUEST,
  TSU_REL_DEPOSIT_DATA_GEOAGE_REQUEST,
  TSU_REL_DEPOSIT_DATA_DEPOSIT_REQUEST,
  TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST,
  TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE,
  TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS,
  TSU_REL_DEPOSIT_DATA_DEPOSIT_FAILURE,
  TSU_REL_DEPOSIT_DATA_DEPOSIT_SUCCESS,
  TSU_REL_DEPOSIT_DATA_GEOAGE_FAILURE,
  TSU_REL_DEPOSIT_DATA_GEOAGE_SUCCESS,
  TSU_REL_DEPOSIT_DATA_PUBLICATION_FAILURE,
  TSU_REL_DEPOSIT_DATA_PUBLICATION_SUCCESS,
  TSU_REL_DEPOSIT_DATA_TSUNAMI_FAILURE,
  TSU_REL_DEPOSIT_DATA_TSUNAMI_SUCCESS,
} from './tsunamiRelatedDepositsReducer';

const deleteDepositSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/tsunamis/deposits/${action.id}`, ...action }),
  requestType: TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST,
  successType: TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS,
  failureType: TSU_REL_DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE,
  successMessage: 'Deleted',
});

const getTsunamiSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}/info`, ...action }),
  requestType: TSU_REL_DEPOSIT_DATA_TSUNAMI_REQUEST,
  successType: TSU_REL_DEPOSIT_DATA_TSUNAMI_SUCCESS,
  failureType: TSU_REL_DEPOSIT_DATA_TSUNAMI_FAILURE,
});

const getDepositsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}/deposits`, ...action }),
  requestType: TSU_REL_DEPOSIT_DATA_DEPOSIT_REQUEST,
  successType: TSU_REL_DEPOSIT_DATA_DEPOSIT_SUCCESS,
  failureType: TSU_REL_DEPOSIT_DATA_DEPOSIT_FAILURE,
});

const getGeoagesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/geologic-ages', ...action }),
  requestType: TSU_REL_DEPOSIT_DATA_GEOAGE_REQUEST,
  successType: TSU_REL_DEPOSIT_DATA_GEOAGE_SUCCESS,
  failureType: TSU_REL_DEPOSIT_DATA_GEOAGE_FAILURE,
});

const getPublicationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/publication-types', ...action }),
  requestType: TSU_REL_DEPOSIT_DATA_PUBLICATION_REQUEST,
  successType: TSU_REL_DEPOSIT_DATA_PUBLICATION_SUCCESS,
  failureType: TSU_REL_DEPOSIT_DATA_PUBLICATION_FAILURE,
});

export const relatedDepositsSagas = [
  deleteDepositSaga,
  getTsunamiSaga,
  getDepositsSaga,
  getGeoagesSaga,
  getPublicationsSaga,
];
